import axiosRef from "axios";

const axios = axiosRef.create({
  baseURL: process.env.REACT_APP_BASE_API_URL, // Centralized base URL
});

// Response interceptor to handle errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized error detected. Redirecting...");
      window.location.href = "/unauthorized"; // Redirect to the error page
    }
    return Promise.reject(error); // Forward the error for custom handling
  }
);

export const fetchAllLeads = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/get-all-leads', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };


  export const fetchLeadStatus = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/get-lead-status', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  export const generateEstimate = async (id, token) => {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/generate-estimate', {lead_id: id}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  export const generateTicket = async (id, token) => {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/generate-ticket', {lead_id: id}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };


  export const fetchLeadDetails = async (token, id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-lead-details/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };
  

  export const fetchDeviceByCategory = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-devices-by-category/${id}`);
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  

  export const UpdateLead = async (token, data) => {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/update-lead', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  export const fetchLeadComments = async (token, id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-lead-notes/${id}`,  {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  export const AddLeadComments = async (token, data) => {
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_API_URL+'/save-lead-note', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  export const fetchTaxClass = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+"/get-tax-class", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };


  export const fetchCustomerGroup = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+"/get-customer-groups", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };



